import { useRegisterSW } from 'virtual:pwa-register/react'

// ── UpdatePrompt ────────────────────────────────────────────────────────
// When a new service worker has been installed in the background, Workbox
// flips `needRefresh` to true. We surface that as a fixed-bottom banner so
// the user can choose when to reload — avoiding silent JS swaps that would
// strand half-filled forms or crash lazy chunks that were imported before
// the bundle changed underneath them.
//
// The banner is self-contained: no props, mount it once near the app root.
// In Vitest the `virtual:pwa-register/react` module is aliased to a stub
// (see vite.config.js), so this component renders null in tests.
export default function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(err) {
      // Don't crash the app if SW registration fails — the site still works
      // as a regular web page, it just doesn't get offline caching.
      console.warn('[sw] registration failed:', err)
    },
  })

  if (!needRefresh) return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9998,
        background: '#0F6E56',
        color: '#fff',
        padding: '12px 16px',
        fontSize: 14,
        fontWeight: 600,
        fontFamily: "'Outfit', sans-serif",
        borderRadius: 12,
        boxShadow: '0 6px 20px rgba(0,0,0,0.18)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      <span style={{ lineHeight: 1.4 }}>
        A new version of Settle is ready.
      </span>
      <button
        type="button"
        onClick={() => updateServiceWorker(true)}
        style={{
          border: 'none',
          background: '#fff',
          color: '#0F6E56',
          fontFamily: 'inherit',
          fontSize: 13,
          fontWeight: 700,
          padding: '8px 14px',
          borderRadius: 8,
          cursor: 'pointer',
          minHeight: 36,
        }}
      >
        Reload
      </button>
      <button
        type="button"
        onClick={() => setNeedRefresh(false)}
        style={{
          border: '1px solid rgba(255,255,255,0.4)',
          background: 'transparent',
          color: '#fff',
          fontFamily: 'inherit',
          fontSize: 13,
          fontWeight: 600,
          padding: '8px 12px',
          borderRadius: 8,
          cursor: 'pointer',
          minHeight: 36,
        }}
        aria-label="Dismiss update notification"
      >
        Later
      </button>
    </div>
  )
}
